import { ReactNode } from 'react';
import classNames from 'classnames';

export default function ListItem(props: {
  children: ReactNode;
  sideContent?: ReactNode;
  sideContentAlign?: 'center' | 'top' | 'bottom';
  className?: string;
  blockContent?: boolean;
}): JSX.Element {
  return (
    <div className={classNames('flex justify-between gap-2 border-b p-4', props.className)}>
      <div className={classNames('grow', { 'pointer-events-none opacity-75': props.blockContent })}>
        <div>{props.children}</div>
      </div>

      <div
        className={classNames('flex flex-col', {
          'justify-center': props.sideContentAlign == 'center',
          'justify-start': props.sideContentAlign == 'top',
          'justify-end': props.sideContentAlign == 'bottom',
          'pointer-events-none opacity-75': props.blockContent,
        })}
      >
        {props.sideContent}
      </div>
    </div>
  );
}
